// Tier 1 (BEGINNER FOUNDATION) — 27 lessons across modules 1.1–1.6.
// Static imports so the PWA bundles lesson data at build time (zero network calls, works offline).
import lessons1to2 from "./axel_lessons_1_1_to_1_2.json";
import lessons3to4 from "./axel-lessons-1.3.1-to-1.4.5.json";
import lessons5to6 from "./axel-lessons-1.5.1-to-1.6.5.json";
import { normalizeLesson } from "./normalizeQuiz";

const unwrap = (src) => (Array.isArray(src) ? src : src?.lessons || []);

export const TIER1_LESSONS = [
  ...unwrap(lessons1to2),
  ...unwrap(lessons3to4),
  ...unwrap(lessons5to6),
].map(normalizeLesson);
